class ProjectScheduleType {
  static KICK_OFF = 'kickoff';
  static CHECK = 'check';
  static FNC_CHECK = 'phone_check';
  static PAYMENT = 'payment';
  static FINISH = 'finnish';
  static BASE_LINE = 'baseline';

  constructor(private code: string) {}

  public value(): string {
    return this.code;
  }

  public static toArray(): string[] {
    return [
      ProjectScheduleType.KICK_OFF,
      ProjectScheduleType.CHECK,
      ProjectScheduleType.FNC_CHECK,
      ProjectScheduleType.PAYMENT,
      ProjectScheduleType.BASE_LINE,
      ProjectScheduleType.FINISH,
    ];
  }

  public isKickOff(): boolean {
    return this.code === ProjectScheduleType.KICK_OFF;
  }

  public isCheckFollowup(): boolean {
    return this.code === ProjectScheduleType.CHECK;
  }

  public isFncCheckPhoneFollowup(): boolean {
    return this.code === ProjectScheduleType.FNC_CHECK;
  }

  public isPayment(): boolean {
    return this.code === ProjectScheduleType.PAYMENT;
  }

  public isBaseLine(): boolean {
    return this.code === ProjectScheduleType.BASE_LINE;
  }

  public isFinish(): boolean {
    return this.code === ProjectScheduleType.FINISH;
  }

  public isKickOffOrFinish(): boolean {
    return this.isKickOff() || this.isFinish();
  }
}

export default ProjectScheduleType;
